import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeTheme } from '../../../store/actions/app.action'

const InitTheme = () => {
    const dispatch = useDispatch()
    const bs_theme = localStorage.getItem('data-bs-theme')
    const { theme } = useSelector(state => state.appReducer)


    React.useEffect(() => {
        if(bs_theme !== theme) {
            dispatch(changeTheme(bs_theme))
        }
    }, [])

    return (
        <>
        </>
    )

}

export default InitTheme